import util from '../util'

let controller = 'Infracao'
export default {
  Listar: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Listar', dto)
  },
  Fechar: function (dto) {
    return util.Axios.Post(controller + '/FecharInfracao', dto)
  },
  DetalhesInfracao: function (id) {
    return util.Axios.Get(controller + '/DetalhesInfracao', id)
  },
  CriarInfracao: function (dto) {
    return util.Axios.Post(controller + '/CriarInfracao', dto)
  },
  ListarTodosPixExternos: function (dto,options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/ListarTodosPixExternos', dto)
  }
}
